module.exports = __webpack_public_path__ + "static/img/moreproduct2-new.4ae50d28.png";